import React from 'react';
import { LeadTypeBadge } from '../LeadTypeBadge';

export const PainelAdminLeadsTab = ({
  vendedores,
  selectedVendedor,
  setSelectedVendedor,
  loadLeads,
  leads,
  handleDeleteLead,
}) => {
  return (
    <>
      <div className="flex items-center gap-3 mb-6">
        <span className="text-4xl">📊</span>
        <div>
          <h2 className="text-2xl font-bold text-gray-900" data-testid="painel-admin-leads-title">Leads por Vendedor</h2>
          <p className="text-gray-600">Selecione um vendedor para ver os leads</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6" data-testid="painel-admin-vendedor-selector-grid">
        {vendedores.map((v) => (
          <button
            key={v.id}
            onClick={() => {
              setSelectedVendedor(v);
              loadLeads(v.id);
            }}
            className={`p-3 border rounded-xl text-left transition ${selectedVendedor?.id === v.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-200'}`}
            data-testid={`painel-admin-select-vendedor-button-${v.id}`}
          >
            <div className="font-medium">{v.nome}</div>
            <div className="text-sm text-gray-500">{v.leads_count || 0} leads</div>
          </button>
        ))}
      </div>

      {selectedVendedor && (
        <div className="border-t pt-4" data-testid="painel-admin-leads-selected-vendedor">
          <h3 className="font-semibold mb-3" data-testid="painel-admin-leads-selected-vendedor-name">Leads de {selectedVendedor.nome}</h3>
          {leads.length === 0 ? (
            <p className="text-gray-500 text-center py-8" data-testid="painel-admin-empty-leads">Nenhum lead registrado</p>
          ) : (
            <div className="space-y-2" data-testid="painel-admin-leads-list">
              {leads.map((lead) => (
                <div key={lead.id} className="border rounded-lg p-3 flex justify-between items-center gap-3" data-testid={`painel-admin-lead-card-${lead.id}`}>
                  <div>
                    <div className="font-medium">{lead.cliente_nome}</div>
                    <div className="text-sm text-gray-500">{lead.cliente_email}</div>
                  </div>
                  <div className="flex items-center gap-3">
                    <LeadTypeBadge type={lead.tipo} className="px-2 py-1 rounded text-xs" />
                    <button
                      type="button"
                      onClick={() => handleDeleteLead(lead)}
                      className="px-3 py-1 bg-red-100 text-red-700 rounded text-sm hover:bg-red-200"
                      data-testid={`painel-admin-delete-lead-button-${lead.id}`}
                    >
                      Excluir
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};
